import {
  PolicyContainer,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
} from "styles/PolicyCommon";

const StudioPrivacy = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyText>
        ㈜커넥트아이(이하“회사”)의 열달후에 스튜디오 무료 촬영 서비스(이하 “무료
        촬영 서비스”)를 이용해 주셔서 감사합니다. 더 좋은 서비스를 만들기 위해
        관련 법령에 따라 개인정보 제3자 제공 동의를 받고 있습니다.
      </PolicyText>
      <PolicyText>
        회사는 무료 촬영 서비스 이용에 반드시 필요한 개인정보를 다음과 같은
        목적을 위하여 처리합니다. 처리하는 개인정보는 다음의 목적 이외의
        용도로는 처리되지 않으며, 처리 목적과 항목이 변경되는 경우에는 별도의
        동의를 받는 등 필요한 조치를 이행할 것입니다.
      </PolicyText>
      <PolicyText>
        회사는 서비스 이용에 필요한 최소한의 개인정보만을 수집하고 있으며,
        제휴사에 제공하고 있습니다. 따라서 필수 항목들만 있으며, 선택 항목은
        없습니다.
      </PolicyText>
      <PolicyText>
        무료 촬영 서비스와 직접 관련된 경우만을 선별하여 무료 촬영 서비스 이용
        시에 필수적인 동의로 처리하고 있으며, 무료 촬영 서비스 이용 시 혜택
        제공을 위한 필수적 항목은 제3자 제공 이용 동의 취소 기능이 제공되지
        않습니다.{" "}
      </PolicyText>

      <PolicySectionTitle>
        개인정보 제3자 제공 처리 목적 및 처리 항목
      </PolicySectionTitle>
      <PolicyArticleTitle>1. 개인정보를 제공받는 자</PolicyArticleTitle>
      <PolicyText>무료 촬영을 신청한 스튜디오</PolicyText>

      <PolicyArticleTitle>2. 제공하는 개인정보 항목</PolicyArticleTitle>
      <PolicyText>신청자 이름, (휴대)전화번호</PolicyText>

      <PolicyArticleTitle>
        3. 개인정보를 제공받는 자의 이용목적
      </PolicyArticleTitle>
      <PolicyText>촬영 관련 일정 상담 및 기타 불만 처리 등 고객관리</PolicyText>

      <PolicyArticleTitle>
        4. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간
      </PolicyArticleTitle>
      <PolicyText>
        개인정보 수집일로부터 6개월 보존합니다. 단, 관계 법령의 규정에 의해 일정
        기간 보존이 필요한 경우에는 해당 기간만큼 보관 후 삭제합니다.
      </PolicyText>

      <PolicySectionTitle>동의를 거부하는 경우에 대한 안내</PolicySectionTitle>
      <PolicyText>
        무료 촬영 서비스의 이용을 위해서 필수적인 동의이므로, 동의를 하지 않으면
        해당 서비스를 이용하실 수 없습니다.
      </PolicyText>

      <PolicySectionTitle>동의 철회를 위한 안내</PolicySectionTitle>
      <PolicyText>
        본 동의를 하시더라도 앱 내 마이메뉴&gt;1:1문의 또는 당사
        고객센터(after10month@connect-i.co.kr)를 통해 동의를 철회하거나 가입
        안내 목적의 연락에 대한 중단을 요청하실 수 있습니다.
      </PolicyText>
    </PolicyContainer>
  );
};

export default StudioPrivacy;
